import {AxiosInstance} from "axios";
import BugDepartmentRepositoryInterface from "@/services/Bug-report/Bug-report/Departments/interfaces";
import {DepartmentEntity} from "@fenix/bug-report-entities/bug-report-entities";
export default class BugDepartmentRepository implements BugDepartmentRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  async create(DTOs: { departmentId: string }[]): Promise<DepartmentEntity[]> {
    const url = '/bug-report/bugs/department';

    const res = await this.axios.post(url, DTOs);
    return res.data;
  }

  async getOne(id: number, relations?: string[]): Promise<DepartmentEntity> {
    const url = `/bug-report/bugs/department/${id}${relations && relations?.length ? `?relations=${relations.toString()}` : ''}`;

    const res = await this.axios.get(url);
    return res.data;
  }

  async updateOne(id: number, departmentId: string): Promise<void> {
    const url = `/bug-report/bugs/department/${id}`;

    const res = await this.axios.patch(url, departmentId);
    return res.data;
  }

  async deleteOne(id: number): Promise<void> {
    const url = `/bug-report/bugs/department/${id}`;
    const res = await this.axios.delete(url);

    return res.data;
  }

  async getAll(page?: number, take?: number): Promise<DepartmentEntity[]> {
    const url = `/bug-report/bugs/department?page=${page ?? ''}&take=${take ?? ''}`;
    const res = await this.axios.get(url);

    return res.data;
  }
}
